import { render } from "./DatePickerNew.vue?vue&type=template&id=8220f078"
import script from "./DatePickerNew.vue?vue&type=script&lang=js"
export * from "./DatePickerNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__